<template>
  <div class="content ht-100v pd-0">
    <go-context-menu ref="gomenu" @on-task-delete="taskDelete">
      <template slot-scope="{ contextData }">
        <go-context-menu-item class="bd-b bg-light dropown">
          <a
            class="nav-link text-uppercase dropdown-toggle"
            id="dropdownMenuTask"
            data-toggle="dropdown"
            role="button"
          >
            <feather type="menu" class="mg-r-5"></feather>{{ contextData.task }}
          </a>
          <!-- <div class="dropdown-menu" aria-labelledby="dropdownMenuTask" style="overflow: auto; max-width: 200px; max-height: 146px">
            <a v-for="(m, i) in listMenu" :key="i" class="dropdown-item text-truncate" role="button" :title="m.nm" @click="$refs.gomenu.close();">
              <feather type="chevron-right" class="mg-r-5"></feather>  
              {{m.nm}}
            </a>
          </div> -->
        </go-context-menu-item>
        <!-- <go-context-menu-item @click.native="$refs.gomenu.close(); editShow(0)" class="bd-b">
          <a class="nav-link text-primary" role="button">
            <feather type="plus-square" class="mg-r-5"></feather>Шинэ
          </a>
        </go-context-menu-item> -->
        <go-context-menu-item
          @click.native="
            $refs.gomenu.close();
            editShow(contextData.id);
          "
          class="bd-b"
        >
          <a class="nav-link" role="button">
            <feather type="edit" class="mg-r-5"></feather>Засах
          </a>
        </go-context-menu-item>
        <go-context-menu-item
          @click.native="
            $refs.gomenu.close();
            showDetail({ mode: 80, obj: contextData });
          "
          class="bd-b"
        >
          <a class="nav-link" role="button">
            <feather type="mouse-pointer" class="mg-r-5"></feather>Дэлгэрэнгүй
          </a>
        </go-context-menu-item>
        <go-context-menu-item
          @click.native="$refs.gomenu.deleteItem(contextData.id)"
        >
          <a class="nav-link text-danger" role="button">
            <feather type="trash-2" class="mg-r-5"></feather>Устгах
          </a>
        </go-context-menu-item>
      </template>
    </go-context-menu>

    <!-- <div class="ag-theme-alpine ag-popup">
      <div ref="cntxtMenu"
        class="ag-menu ag-ltr ag-popup-child"
        role="presentation"
        :style="
          `min-wdith: 229px; display: ${
            contextShow ? 'block' : 'none'
          }; position: absolute; left: ${context.pos.left}px; top: ${
            context.pos.top
          }px; z-index: 1;`
        "
      >
        <div class="ag-menu-list ag-focus-managed" role="tree">
          <div
            class="ag-tab-guard ag-tab-guard-top"
            role="presentation"
            tabindex="0"
          ></div>
          <div
            class="ag-menu-option"
            tabindex="-1"
            role="button"
            aria-level="1"
            @click="showDetail({mode: 80, obj: { id: context.rowId }})"
          >
            <span
              ref="eIcon"
              class="ag-menu-option-part ag-menu-option-icon"
              role="button"
              ><span
                class="ag-icon ag-icon-paste"
                unselectable="on"
                role="presentation"
              ></span></span
            ><span ref="eName" class="ag-menu-option-part ag-menu-option-text"
              >Дэлгэрэнгүй</span
            >
          </div>
          <div
            class="ag-menu-option"
            tabindex="-1"
            role="button"
            aria-disabled="true"
            aria-level="1"
          >
            <span
              ref="eIcon"
              class="ag-menu-option-part ag-menu-option-icon"
              role="presentation"
              ><span
                class="ag-icon ag-icon-edit"
                unselectable="on"
                role="presentation"
              ></span></span
            ><span ref="eName" class="ag-menu-option-part ag-menu-option-text"
              >Засах</span
            >
          </div>
          <div class="ag-menu-separator" aria-hidden="true">
            <div class="ag-menu-separator-part"></div>
            <div class="ag-menu-separator-part"></div>
            <div class="ag-menu-separator-part"></div>
            <div class="ag-menu-separator-part"></div>
          </div>
          <div
            class="ag-menu-option"
            tabindex="-1"
            role="button"
            aria-disabled="true"
            aria-level="1"
          >
            <span
              ref="eIcon"
              class="ag-menu-option-part ag-menu-option-icon"
              role="presentation"
              ><span
                class="ag-icon ag-icon-delete"
                unselectable="on"
                role="presentation"
              ></span></span
            ><span ref="eName" class="ag-menu-option-part ag-menu-option-text"
              >Устгах</span
            >
          </div>
        </div>
      </div>
    </div> -->

    <task-edit
      :prms.sync="taskEdit"
      :show.sync="taskEdit.show"
      @on-attach="showFile($event)"
      @on-task-posted="taskPosted"
      @on-edit-close="editClosed"
    ></task-edit>
    <project-users
      :show="projectEdit.show"
      :obj.sync="project"
      module="project"
      @on-edit-close="projectUsersClosed"
      @on-share="showMention"
    ></project-users>
    <mention-users
      :show="projectMention.show"
      :obj.sync="project"
      module="project"
      @on-mention-close="projectMention.show = false"
    ></mention-users>

    <project-steps
      :show="projectStep.show"
      :obj.sync="project"
      @on-mention-close="projectStep.show = false"
    ></project-steps>

    <task-detail-side
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      @on-task-detail="showDetail"
      @on-task-reload="showDetail"
      @on-task-close="taskDialogSide.id = 0"
      @on-task-delete="onTaskDelete"
      @on-duplicated="onDuplicated"
      @on-edit-profile="onEditProfile"
      @on-attendence="onAttendence"
      @on-row-updated="initRow"
    ></task-detail-side>

    <task-detail
      v-if="taskDialog.id > 0"
      :id.sync="taskDialog.id"
      @on-attach="showFile($event)"
      @on-task-detail="showDetail"
      @on-task-reload="showDetail"
      @on-task-loaded="taskLoaded"
      @on-task-delete="onTaskDelete"
      @on-task-close="
        taskDialog.id = 0;
        taskLoaded();
      "
      @on-task-transfered="
        taskDialog.id = 0;
        init(true, $event);
      "
      @on-project-changed="
        taskDialog.id = 0;
        init(true);
        showDetail({ mode: 80, obj: { id: $event } });
      "
    ></task-detail>

    <template v-else>
      <div ref="mainHeader" class="content-header bd-b pd-0 gosm-toolbar">
        <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px">
          <div class="dropdown" v-if="listSetting.mainMenu">
            <a
              class="navbar-brand tx-bold tx-spacing--2 order-1"
              data-toggle="dropdown"
              role="button"
            >
              <button class="btn btn-xs btn-white btn-uppercase">
                <feather
                  type="settings"
                  class="wd-20-f ht-20-f mg-r-5"
                ></feather
                >Тохиргоо
              </button>
            </a>
            <div class="dropdown-menu tx-13">
              <!-- <a href="javascript:void(0)" class="dropdown-item">Загвар</a> -->
              <a
                @click="showMention()"
                href="javascript:void(0)"
                class="dropdown-item"
                >Хуваалцах</a
              >
              <a
                @click="projectSteps()"
                href="javascript:void(0)"
                class="dropdown-item"
                >Алхмын тохиргоо</a
              >
              <a
                @click="projectUsers()"
                href="javascript:void(0)"
                class="dropdown-item"
                >Эрхийн тохиргоо</a
              >
              <a
                v-if="ot == 115"
                @click="lrningRptShow()"
                href="javascript:void(0)"
                class="dropdown-item"
                >Тайлан</a
              >
              <a
                v-if="
                  ot == 138 &&
                  $store.state.app.activeGroup.id == 9249 &&
                  isHrAdmin()
                "
                @click="syncGolomtDepart()"
                href="javascript:void(0)"
                class="dropdown-item"
                >Байгууллагын бүтэц татах</a
              >
              <a
                v-if="
                  ot == 138 &&
                  $store.state.app.activeGroup.id == 9249 &&
                  isHrAdmin()
                "
                @click="syncGolomtUsers()"
                href="javascript:void(0)"
                class="dropdown-item"
                >Хэрэглэгчийн мэдээлэл татах</a
              >
              <!-- <a href="javascript:void(0)" class="dropdown-item">Алхмын тохиргоо</a>
              <a href="javascript:void(0)" class="dropdown-item">Тохиргоо</a>-->
            </div>
          </div>
          <div v-else-if="listSetting.closeBtnShow">
            <a
              class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto"
              @click="$emit('on-close')"
            >
              <feather type="x"></feather>
            </a>
          </div>

          <div class="bd-l pd-l-10">{{ project.title }}</div>

          <a
            class="navbar-toggler order-2"
            type="button"
            data-toggle="collapse"
            :data-target="`#navbarSupportedContent_${project.id}`"
            :aria-controls="`navbarSupportedContent_${project.id}`"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <feather type="menu" class="wd-20 ht-20"></feather>
          </a>
          <div
            class="collapse navbar-collapse order-2"
            :id="`navbarSupportedContent_${project.id}`"
          >
            <div class="mg-l-auto">
              <a
                v-if="listSetting.newBtnShow"
                class="btn btn-sm pd-x-15 btn-primary btn-uppercase text-white"
                @click="editShow(0)"
              >
                <feather type="plus" class="m-r-5"></feather>Шинэ
              </a>
              <a
                v-if="listSetting.closeBtnShow"
                @click="forceClose"
                class="
                  btn btn-sm
                  pd-x-15
                  btn-uppercase
                  mg-l-5
                  btn-danger
                  text-white
                "
              >
                <feather type="x" class="m-r-5"></feather>Хаах
              </a>
            </div>
          </div>
        </nav>
      </div>
      <div class="content-body pd-x-0 pd-y-0 overflow-hidden">
        <div class="container-fluid pd-x-0" id="cstmScrll">
          <loader-list
            v-if="isSpecialOt(ot)"
            :ot="ot"
            :prms="{ searches: searches, fields: fields, tasks: tasks }"
          />
          <div v-else class="row no-gutters">
            <div
              :class="`pos-relative bg-gray-50`"
              :style="{ width: listSetting.leftSidebar ? '20%' : '0' }"
            >
              <div
                v-if="listSetting.statisticLoad"
                class="row"
                ref="sideTop"
              ></div>

              <vue-custom-scrollbar
                :style="`height:${scrSideHeight}px`"
                :settings="{ maxScrollbarLength: 60 }"
                class=""
              >
                <task-searches
                  ref="srchFields"
                  :key="searchesKey"
                  :searches="searches"
                  :filterModelProp="filterModel"
                  @on-search="onSearchFired"
                  @on-export="exportCoreList"
                  @on-site-detail="showDetail($event)"
                  @on-site-edit="onSiteEdit($event)"
                  @on-site-add="onSiteAdd($event)"
                  @on-add-item="onAddItem($event)"
                  @on-add-item-root="onAddItemRoot($event)"
                  @on-add-work="onAddWork($event)"
                  @on-item-detial="showDetail($event)"
                  @on-edit-item="onEdittem"
                ></task-searches>
              </vue-custom-scrollbar>

              <div
                class="d-none d-md-block text-center bd-t"
                ref="sideBtm"
                style="height: 39px"
              >
                <div class="d-flex align-items-center justify-content-between" role="group" 
                style="height: 39px" >
                  <div title="Экспорт" alt="Экспорт"
                    @click="exportCoreHandle()"
                    type="button"
                    class="bd-r flex-fill"
                  >
                    <feather type="download" size="32" class="mg-r-5"></feather>
                    <!-- <span>Экспорт</span> -->
                  </div>
                  <div title="Хайх" alt="Хайх"
                    @click="search()"
                    type="button"
                    class="bd-r flex-fill"
                  >
                    <feather type="filter" size="32" class="mg-r-5"></feather>
                    <!-- <span>Хайх</span> -->
                  </div>
                  <div title="Бүгд" alt="Бүгд"
                    @click="filterReset()"
                    role="button"
                    class="flex-fill"
                  >
                    <feather type="refresh-ccw" class="mg-r-5"></feather>
                    <!-- <span>Бүгд</span> -->
                  </div>
                  <button
                    v-if="ot == 463 || ot == 472"
                    @click="exportList()"
                    type="button"
                    class="btn btn-xs btn-secondary"
                  >
                    <feather type="download" class="mg-r-5"></feather>
                    <span>Excel</span>
                  </button>
                </div>
              </div>
            </div>
            <div
              :class="`pos-relative ${listSetting.leftSidebar ? 'bd-l' : ''}`"
              :style="{ width: listSetting.leftSidebar ? '80%' : '100%' }"
            >
              <!-- <ag-grid-vue
                style="width: 100%; height: calc(100vh - 105px);"
                class="ag-theme-alpine go-ag-grid d-none"
                :columnDefs="columnDefs"
                :modules="modules"
                :defaultColDef="defaultColDef"
                :postProcessPopup="postProcessPopup"
                :rowData="rowData"
                @grid-ready="onGridReady"
                @cellContextMenu="cellContextMenu"
                @cellClicked="cellClicked"
              >
              </ag-grid-vue> -->

              <div
                ref="listHeader"
                class="row no-gutters bg-list-header bg-gray-200"
              >
                <div
                  class="
                    wd-25
                    text-center
                    tx-10
                    align-items-center
                    justify-content-center
                    d-flex
                    tx-color-03
                  "
                >
                  #
                </div>
                <div
                  :class="`tx-10 align-items-center d-flex tx-color-03 bd-l text-uppercase pd-3`"
                  :style="`width: ${f.span}%;`"
                  v-for="(f, i) in fields"
                  :key="i"
                >
                  <!-- {{f.field}} -->
                  <!-- <div class="input-group" v-if="f.flag == 1 || f.flag == 11">
                    <input
                      v-on:keyup="checkSearch"
                      v-model="$data['filterModel'][f.field]"
                      :placeholder="f.title"
                      class="form-control pd-y-0-f pd-x-10 text-uppercase tx-11"
                      style="height: 24px"
                    />
                    <div
                      class="input-group-append"
                      v-show="
                        $data['filterModel'][f.field] != null &&
                        $data['filterModel'][f.field] != ''
                      "
                    >
                      <a
                        @click="
                          $data['filterModel'][f.field] = null;
                          search();
                        "
                        class="btn btn-outline-light pd-x-5-f"
                        style="height: 24px; padding-top: 5px"
                        role="button"
                      >
                        <feather type="x"></feather>
                      </a>
                    </div>
                  </div> -->
                  <span class="font-weight-bold">{{ f.title }}</span>
                </div>
                <!-- <input type="submit" @click="search()" class="d-none" /> -->
              </div>

              <vue-custom-scrollbar
                class="bg-white"
                :style="`height:${scrHeight}px`"
                :settings="{ maxScrollbarLength: 60 }"
              >
                <div v-if="!loading" class="d-list">
                  <div v-if="tasksCount == 0" class>
                    <div class>
                      <div
                        class="
                          ht-700
                          d-flex
                          flex-column
                          align-items-center
                          justify-content-center
                        "
                      >
                        <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
                          <img
                            src="assets/img/img22.png"
                            class="img-fluid"
                            alt
                          />
                        </div>
                        <p class="tx-color-03 mg-b-30">
                          Жагсаалт хоосон байна.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    v-for="(t, i) in tasks"
                    :key="i"
                    @click.prevent.stop="handleClick($event, t)"
                    class="d-row"
                  >
                    <div
                      v-if="isDrawGroupDateRange(i)"
                      class="row no-gutters core-list-group bg-gray-50"
                    >
                      <div class="col text-lowercase tx-12">
                        <div class="pd-l-10 pd-y-2 font-weight-semibold tx-color-04">
                          {{ t[showGroupLabel()] }}
                        </div>
                      </div>
                    </div>
                    <div
                      @contextmenu.prevent="$refs.gomenu.open($event, t)"
                      role="button"
                      @click="showDetail({ mode: 80, obj: t })"
                      class="row highlight no-gutters list-row"
                    >
                      <div
                        class="
                          wd-25
                          no-gutters
                          align-items-center
                          d-flex
                          justify-content-end
                        "
                      >
                        <div class="text-right tx-color-04 pr-1 tx-10 tx-robot">
                          {{ (pager.current - 1) * pager.perPage + i + 1 }}
                        </div>
                        <!-- <div class="wd-25 text-center bg-gray-100 bd-l pt-1" @click.stop>
                          <input
                            @click.stop
                            type="checkbox"
                            role="button"
                            class="tx-color-03"
                          />
                        </div> -->
                      </div>
                      <dynamic-cell
                        @show-detail="showDetail"
                        :name="t.id + '_' + i"
                        :t="t"
                        :f="f"
                        :listSetting="listSetting"
                        :projectStat="projectStat"
                        :nowDate="nowDate"
                        :style="`width: ${f.span}%`"
                        v-for="(f, i) in fields"
                        :key="i"
                        @on-attach="showFile($event)"
                        @on-popover="popoverShowShow"
                        @on-user-info="handleUserInfoModal"
                        @on-show-pinnedUsers="showPinnerUsers"
                        @on-show-point="showMemberPoint"
                        @on-update-field="updField"
                      ></dynamic-cell>
                    </div>
                  </div>
                </div>
                <div v-else></div>

                <b-popover
                  :target="`popover-reactive-${popover.target}`"
                  triggers="click"
                  :title="`${popover.title}`"
                  :key="popover.key"
                  :show.sync="popoverShow"
                  no-fade
                  placement="right"
                  @show="onShow"
                  @shown="onShown"
                  @hidden="onHidden"
                  custom-class="clmn-pppvr"
                >
                  <div style="height: 400px; overflow: auto">
                    <ul class="nav nav-line pd-x-10">
                      <li class="nav-item">
                        <a
                          class="nav-link active"
                          id="home-tab5"
                          data-toggle="tab"
                          href="#home5"
                          role="tab"
                          aria-controls="home"
                          aria-selected="true"
                          >Явц</a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          id="profile-tab5"
                          data-toggle="tab"
                          href="#profile5"
                          role="tab"
                          aria-controls="profile"
                          aria-selected="false"
                          >Гүйцэтгэл</a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          id="contact-tab5"
                          data-toggle="tab"
                          href="#contact5"
                          role="tab"
                          aria-controls="contact"
                          aria-selected="false"
                          >Тэмдэглэл</a
                        >
                      </li>
                    </ul>
                    <div class="mg-10">
                      <task-process
                        v-if="popover.load"
                        :id.sync="popover.target"
                      ></task-process>
                    </div>
                  </div>
                </b-popover>
              </vue-custom-scrollbar>

              <div
                ref="listFooter"
                class="go-core-list-footer
                  py-2
                  d-flex
                  align-items-center
                  justify-content-between
                  bd-t
                  bg-gray-50
                "
                v-show="tasksCount > 0"
              >
                <div class="pd-l-10">
                  <div
                    @click="listSetting.leftSidebar = !listSetting.leftSidebar"
                    role="button"
                    class="tx-color-03"
                  >
                    <feather
                      v-if="listSetting.leftSidebar"
                      type="arrow-left"
                      class="wd-20-f ht-20-f"
                    ></feather>
                    <feather
                      v-else
                      type="arrow-right"
                      class="wd-20-f ht-20-f"
                    ></feather>
                  </div>
                  <!-- <a @click="init(true)" role="button">
                    <feather
                      type="refresh-cw"
                      class="wd-20 ht-20 text-muted mg-r-10 mg-t-5"
                    ></feather>
                  </a> -->
                </div>
                <div class="page">
                  <b-pagination
                    size="sm"
                    pills
                    align="center"
                    v-model="pager.current"
                    :total-rows="tasksCount"
                    :per-page="pager.perPage"
                    @change="pageChanged"
                    style="margin-bottom: 0"
                  ></b-pagination>
                </div>
                <div class="pd-x-5 text-muted tx-12">
                  Нийт:
                  <span class="font-weight-bold">{{ tasksCount }}</span> бичилт.
                  Харагдаж буй:
                  <span class="font-weight-bold">{{
                    (pager.current - 1) * pager.perPage + 1
                  }}</span>
                  -
                  <span class="font-weight-bold">{{
                    (pager.current - 1) * pager.perPage + tasks.length
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />

    <b-modal
      width="1000"
      hide-footer
      size="lg"
      scrollable
      v-model="createdUser.modal"
      title="Хэрэглэгч сонгох"
    >
      <div>
        <table class="wd-100p table-bordered table-striped">
          <thead>
            <tr>
              <th>№</th>
              <th>Төрөл</th>
              <th>Нэр</th>
              <th>Нэвтрэх нэр (Бүртгэл №)</th>
              <th>Регистр №</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              @click="handleUserInfoModal(u.id)"
              v-for="(u, i) in createdUser.list"
              :key="i"
              class="is-pointer"
            >
              <td>{{ i + 1 }}</td>
              <td>{{ u.locType4Name }}</td>
              <td>{{ u.fullName }}</td>
              <td>{{ u.loginName }}</td>
              <td>{{ u.register }}</td>
              <td class="text-right pd-r-5 pd-y-5">
                <button
                  @click.stop="
                    createdUser.curId = u.id;
                    createdUser.modal = false;
                  "
                  type="button"
                  class="btn btn-outline-primary btn-xs"
                >
                  <span>Сонгох</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal v-model="duplicateData.modal" title="Тохиргоо" size="lg">
      <div class="d-flex">
        <form class="pd-20 pd-r-40">
          <div class="form-group mg-b-0 row">
            <label class="col-form-label pd-t-20 d-block">Сургалтын нэр</label>
            <input
              v-model="duplicateData.course.task"
              maxlength="450"
              class="form-control"
              placeholder="Сургалтын нэр"
            />
          </div>
          <div class="form-group mg-b-0 row">
            <label class="col-form-label pd-t-20 d-block">Эхлэх огноо</label>
            <DatePicker
              v-model="duplicateData.course.startDate"
              placeholder="Огноо сонгоно уу"
              type="datetime"
              style="width: 100%"
              :format="'yyyy-MM-dd HH:mm:ss'"
              :value-format="'yyyy-MM-dd HH:mm:ss'"
            ></DatePicker>
          </div>
          <div class="form-group mg-b-0 row">
            <label class="col-form-label pd-t-20 d-block">Дуусах огноо</label>
            <DatePicker
              v-model="duplicateData.course.endDate"
              placeholder="Огноо сонгоно уу"
              type="datetime"
              style="width: 100%"
              :format="'yyyy-MM-dd HH:mm:ss'"
              :value-format="'yyyy-MM-dd HH:mm:ss'"
            ></DatePicker>
          </div>
          <div class="form-group mg-b-0 row">
            <label class="col-form-label pd-t-20 d-block"
              >Хүсэлт авч эхлэх огноо</label
            >
            <DatePicker
              v-model="duplicateData.course.requestStartDate"
              placeholder="Огноо сонгоно уу"
              type="datetime"
              style="width: 100%"
              :format="'yyyy-MM-dd HH:mm:ss'"
              :value-format="'yyyy-MM-dd HH:mm:ss'"
            ></DatePicker>
          </div>
          <div class="form-group mg-b-0 row">
            <label class="col-form-label pd-t-20 d-block"
              >Хүсэлт авч дуусах огноо</label
            >
            <DatePicker
              v-model="duplicateData.course.requestEndDate"
              placeholder="Огноо сонгоно уу"
              type="datetime"
              style="width: 100%"
              :format="'yyyy-MM-dd HH:mm:ss'"
              :value-format="'yyyy-MM-dd HH:mm:ss'"
            ></DatePicker>
          </div>
        </form>
        <div class="bd-l pd-l-20">
          <h6
            class="
              tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold
              mg-b-8
            "
          >
            Шалгалт
          </h6>
          <div class="card" v-for="(e, i) in duplicateData.exams" :key="i">
            <div class="card-body">
              <div class="form">
                <div class="form-group mg-b-0 row">
                  <label class="col-form-label pd-t-20 d-block"
                    >Шалгалтын нэр</label
                  >
                  <input
                    v-model="e.name"
                    maxlength="450"
                    class="form-control"
                    placeholder="Шалгалтын нэр"
                  />
                </div>
                <div class="form-group mg-b-0 row">
                  <label class="col-form-label pd-t-20 d-block"
                    >Эхлэх огноо</label
                  >
                  <DatePicker
                    v-model="e.startDate"
                    placeholder="Огноо сонгоно уу"
                    type="datetime"
                    style="width: 100%"
                    :format="'yyyy-MM-dd HH:mm:ss'"
                    :value-format="'yyyy-MM-dd HH:mm:ss'"
                  ></DatePicker>
                </div>
                <div class="form-group mg-b-0 row">
                  <label class="col-form-label pd-t-20 d-block"
                    >Дуусах огноо</label
                  >
                  <DatePicker
                    v-model="e.endDate"
                    placeholder="Огноо сонгоно уу"
                    type="datetime"
                    style="width: 100%"
                    :format="'yyyy-MM-dd HH:mm:ss'"
                    :value-format="'yyyy-MM-dd HH:mm:ss'"
                  ></DatePicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <b-button @click="duplicateData.modal = false" variant="danger"
          >Болих</b-button
        >
        <b-button @click="duplicateDataSubmit" variant="primary"
          >Хадгалах</b-button
        >
      </template>
    </b-modal>

    <b-modal v-model="memberPoint.modal" title="Онооны задаргаа" hide-footer>
      {{ memberPoint.user.fullName }}
      <go-points
        class="mg-t-20"
        :userId="memberPoint.user.userId"
        :userTaskId="memberPoint.user.id"
      />
    </b-modal>

    <b-modal
      v-model="editProfile.modal"
      :title="`${editProfile.obj.task}-н мэдээлэл шинэчлэх`"
      hide-footer
      size="xl"
    >
      <user-profile-edit
        :manager="true"
        :propId="editProfile.obj.id"
      ></user-profile-edit>
    </b-modal>

    <b-modal v-model="lrningRpt.modal" centered title="Нийт сургалтын тайлан">
      <Form label-position="right" label-width="100px">
        <FormItem label="Эхлэх огноо">
          <DatePicker
            v-model="lrningRpt.startDate"
            placeholder="Огноо сонгоно уу"
            type="date"
            style="width: 100%"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
          ></DatePicker>
        </FormItem>
        <FormItem label="Дуусах огноо">
          <DatePicker
            v-model="lrningRpt.endDate"
            placeholder="Огноо сонгоно уу"
            type="date"
            style="width: 100%"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
          ></DatePicker>
        </FormItem>
      </Form>
      <template #modal-footer>
        <b-button @click="lrningRpt.modal" variant="danger">Болих</b-button>
        <b-button @click="lrningRptOk" variant="primary">Хадгалах</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { getStatisticByProjectId } from "@/api/column";
import { getCoreList, getListFields, getSearchFields } from "@/api/taskCore";
import { request } from "@/api/all";
import { mapActions } from "vuex";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { hasOneOf } from "@/libs/tools";

var _ = require("lodash");
const moment = require("moment");

import {
  getInheritedTask,
  postInheritedTask,
  taskInheritedDetail,
} from "@/api/task";

//import { AgGridVue } from "ag-grid-vue";
//import {AllCommunityModules} from '@ag-grid-community/all-modules';
// import { AllModules } from '@ag-grid-enterprise/all-modules';

import "element-ui/lib/theme-chalk/index.css";
import {
  Input,
  Form,
  FormItem,
  RadioGroup,
  Radio,
  Notification,
  Select,
  Option,
  DatePicker,
} from "element-ui";
import Buttons from "../../../components/task/components/transfers/buttons.vue";

export default {
  components: {
    //AgGridVue,
    Input,
    Select,
    Option,
    Form,
    FormItem,
    RadioGroup,
    Radio,
    DatePicker,
    Notification,
    vueCustomScrollbar,
    taskSearches: () => ({
      component: import("@/components/project/searches.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    cmmsFinder: () => ({
      component: import("@/components/task/list/components/cmmsFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    // taskDialog: () => ({
    //   component: import("@/components/task/detail/dialog.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    taskDetail: () => ({
      component: import("@/components/task/detail/default.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    projectUsers: () => ({
      component: import("@/components/project/users.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mentionUsers: () => ({
      component: import("@/components/project/mention.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    projectSteps: () => ({
      component: import("@/components/project/step.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    dynamicCell: () => ({
      component: import("@/components/task/list/components/cell"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    dynamicCellAg: () => ({
      component: import("@/components/task/list/components/cellAg"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskFinder: () => ({
      component: import("@/components/task/edit/components/taskFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    dropDown: () => ({
      component: import("@/components/task/edit/components/dropDown"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskProcess: () => ({
      component: import("@/components/task/components/process/taskProcess.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    loaderList: () => ({
      component: import("@/views/modules/task/list/special/loader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    Buttons,
    goPoints: () => ({
      component: import("@/views/modules/lms/components/points"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    userProfileEdit: () => ({
      component: import("@/views/modules/sys/profile"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    goContextMenu: () => ({
      component: import("@/components/plugins/contextMenu"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    goContextMenuItem: () => ({
      component: import("@/components/plugins/contextMenu/item.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data: () => ({
    listMenu: [],
    memberPoint: {
      modal: false,
      user: {},
    },
    createdUser: {
      mode: "1",
      value: "",
      list: [],
      modal: false,
      curId: 0,
    },
    forceLoad: false,
    ot: -1,
    otTmp: -1,
    mode: 0,
    fetched: false,
    loading: false,
    project: {
      id: 0,
      title: "",
    },
    searchesKey: 0,
    searches: [],
    fields: [],
    scrHeight: 600,
    scrSideHeight: 600,
    tasks: [],
    nowDate: "",
    filterModel: {
      task: "",
      systemFlag: null,
    },
    tasksCount: 0,
    pager: {
      perPage: 50,
      current: 1,
    },
    taskDialog: {
      show: false,
      id: 0,
      key: 0,
    },
    taskDialogSide: {
      show: false,
      id: 0,
      key: 0,
    },
    taskEdit: {
      id: 0,
      show: false,
      render: false,
      objectTypeId: 0,
      projectId: 0,
    },
    projectEdit: {
      id: 0,
      redner: false,
      show: false,
      mode: 0,
    },
    projectStep: {
      show: false,
    },
    projectMention: {
      show: false,
    },
    projectStat: {
      columns: [],
    },
    listSetting: {
      leftSidebar: true,
      newBtnShow: true,
      statisticLoad: true,
      closeBtnShow: false,
      mainMenu: true,
      chooser: false,
    },
    fileDialog: {
      show: false,
      id: 0,
    },
    popover: {
      target: 0,
      key: 0,
      show: false,
      title: "",
      load: false,
    },
    popoverShow: false,
    listOptions: [],
    routeConfig: {
      edit: 0,
      detail: 0,
    },

    columnDefs: null,
    defaultColDef: {
      flex: 1,
      minWidth: 150,
      filter: true,
      sortable: true,
      floatingFilter: true,
    },
    rowData: null,
    //modules: AllModules,
    postProcessPopup: null,
    // context: {
    //   rowId: 0,
    //   //show: false,
    //   pos: {
    //     left: 0,
    //     top: 0,
    //   },
    // },
    // contextShow: false,
    // gridApi: null,
    // modules: AllCommunityModules,
    duplicateData: {
      course: {},
      exams: [],
      modal: false,
    },
    editProfile: {
      modal: false,
      obj: {
        id: 0,
        task: "",
      },
    },
    lrningRpt: {
      modal: false,
      startDate: null,
      endDate: null,
    },
  }),
  props: {
    prms: {
      type: Object,
      default: () => {},
    },
    prmsProp: {
      type: Object,
      default: () => {},
    },
  },
  beforeMount() {
    this.postProcessPopup = (params) => {
      if (params.type !== "columnMenu") {
        return;
      }
      var columnId = params.column.getId();
      if (columnId === "gold") {
        var ePopup = params.ePopup;
        var oldTopStr = ePopup.style.top;
        oldTopStr = oldTopStr.substring(0, oldTopStr.indexOf("px"));
        var oldTop = parseInt(oldTopStr);
        var newTop = oldTop + 25;
        ePopup.style.top = newTop + "px";
      }
    };
  },
  mounted() {
    // var eBody = document.querySelector(".ag-body-viewport");
    // eBody.addEventListener("contextmenu", function(event) {
    //   event.preventDefault();
    // });
    if (this.prms != undefined && this.prms.objectTypeId != undefined) {
      this.mode = this.prms.mode;
      //console.log(this.prms.objectTypeId)
      //console.log('this.mode', this.mode);
      if (this.mode == 50) {
        this.listSetting.mainMenu = false;
        this.listSetting.closeBtnShow = true;
        this.listSetting.statisticLoad = false;
        this.listSetting.chooser = true;

        if (
          (this.prms.objectTypeId == 544 ||
            this.prms.objectTypeId == 545 ||
            this.prms.objectTypeId == 546 ||
            this.prms.objectTypeId == 547) &&
          this.prms.parentTaskId != undefined &&
          this.prms.parentTaskId != null
        ) {
          this.filterModel.organizationTaskId = this.prms.parentTaskId;

          if (this.prms.objectTypeId == 544) {
            this.filterModel.isRepeat = true;
          }
        }
        //console.log( this.prms);
      } else if (this.mode == 51) {
        this.listSetting.newBtnShow = false;
        this.listSetting.mainMenu = false;
        this.listSetting.closeBtnShow = true;
        this.listSetting.statisticLoad = false;
        this.listSetting.chooser = true;
      } else if (this.mode == -100) {
        this.listSetting.newBtnShow = false;
        this.listSetting.mainMenu = false;
        this.listSetting.closeBtnShow = true;
        this.listSetting.statisticLoad = false;
        this.listSetting.chooser = true;
      }

      this.forceLoad = true;
      this.$nextTick(() => {
        this.build(this.prms.objectTypeId, 0, 0);
      });
    } else {
      this.forceLoad = true;
      this.$nextTick(() => {
        this.build(
          this.$route.params.ot,
          this.$route.params.edit,
          this.$route.params.detail
        );
      });
    }
  },
  // beforeCreate() {
  //   require("../../../../node_modules/ag-grid-community/dist/styles/ag-grid.css");
  //   require("../../../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css");
  // },
  beforeDestroy() {
    this.tasks = [];
    this.fields = [];
    window.removeEventListener("resize", this.getWindowHeight);
  },
  methods: {
    ...mapActions(["handleLoading", "handleAside", "handleUserInfoModal"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    lrningRptOk() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: {
          method: "GET",
          url: "v2/LearnReport/ReportByLearnerAllCourseDetailed",
        },
        params: {
          startDate: this.lrningRpt.startDate,
          endDate: this.lrningRpt.endDate,
          mode: 1,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.showFile(res.data.file.id);
          this.lrningRpt.modal = false;
        }
      });
    },
    lrningRptShow() {
      this.lrningRpt.modal = true;
    },
    build(ot, edit, detail) {
      if (ot == 506 || ot == 507 || ot == 508 || ot == 535) {
        this.listSetting.newBtnShow = false;
      }

      this.routeConfig.edit = parseInt(edit, 10);
      this.routeConfig.detail = parseInt(detail, 10);
      this.ot = parseInt(ot, 10);
      this.otTmp = this.ot;

      if (this.otTmp == 390) {
        this.ot = 138;
        this.filterModel.systemFlag = 6;
      } else if (this.otTmp == 138) {
        this.filterModel.systemFlag = 1;
      }

      if (!this.listSetting.chooser) {
        if (
          this.$route.params.locTypeId != undefined &&
          parseInt(this.$route.params.locTypeId, 10) != 0
        ) {
          this.filterModel.locTypeId = parseInt(
            this.$route.params.locTypeId,
            10
          );
        }

        if (
          this.$route.params.organizationTaskId != undefined &&
          parseInt(this.$route.params.organizationTaskId, 10) != 0
        ) {
          this.filterModel.organizationTaskId = parseInt(
            this.$route.params.organizationTaskId,
            10
          );
        }

        if (
          this.$route.params.secondOrganizationTaskId != undefined &&
          parseInt(this.$route.params.secondOrganizationTaskId, 10) != 0
        ) {
          this.filterModel.secondOrganizationTaskId = parseInt(
            this.$route.params.secondOrganizationTaskId,
            10
          );
        }

        if (
          this.$route.params.task1_ltId3 != undefined &&
          parseInt(this.$route.params.task1_ltId3, 10) != 0
        ) {
          if (
            this.filterModel.organizationTask == undefined ||
            this.filterModel.organizationTask == null
          ) {
            this.filterModel.organizationTask = {
              locTypeId3: parseInt(this.$route.params.task1_ltId3, 10),
            };
          } else {
            this.filterModel.organizationTask.locTypeId3 = parseInt(
              this.$route.params.task1_ltId3,
              10
            );
          }
        }

        if (
          this.$route.params.task2_ltId != undefined &&
          parseInt(this.$route.params.task2_ltId, 10) != 0
        ) {
          if (
            this.filterModel.secondOrganizationTask == undefined ||
            this.filterModel.secondOrganizationTask == null
          ) {
            this.filterModel.secondOrganizationTask = {
              locTypeId: parseInt(this.$route.params.task2_ltId, 10),
            };
          } else {
            this.filterModel.secondOrganizationTask.locTypeId = parseInt(
              this.$route.params.task2_ltId,
              10
            );
          }
        }

        if (
          this.$route.params.locTypeId1 != undefined &&
          parseInt(this.$route.params.locTypeId1, 10) != 0
        ) {
          this.filterModel.locTypeId1 = parseInt(
            this.$route.params.locTypeId1,
            10
          );
        }

        if (
          this.$route.params.isTender != undefined &&
          parseInt(this.$route.params.isTender, 10) != 0
        ) {
          this.filterModel.isTender = this.$route.params.isTender;
        }

        if (
          this.$route.params.isCompleted != undefined &&
          parseInt(this.$route.params.isCompleted, 10) != 0
        ) {
          this.filterModel.isCompleted = this.$route.params.isCompleted;
        }

        if (
          this.$route.params.currentColumnId != undefined &&
          parseInt(this.$route.params.currentColumnId, 10) != 0
        ) {
          this.filterModel.currentColumnId = parseInt(
            this.$route.params.currentColumnId,
            10
          );
        }
      }

      let prjs = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == this.ot
      );
      if (prjs != undefined && prjs.length) {
        //console.log('stp1');
        this.project = prjs[0];
        if (this.otTmp == 390) this.project.title = "Гишүүнчлэл";
        //this.projectMention.show= true;
        //this.showMention();

        this.tasks = [];

        this.initFileds();
        this.initSearch();
      } else {
        if (
          this.$route.params.projectId != undefined ||
          this.$route.params.projectId != null
        ) {
          //console.log(this.$route.params.projectId);
          this.project.id = this.$route.params.projectId;
          if (this.$route.params.projectId == 0) {
          }
          //console.log('stp2', this.project.id, this.$route);

          this.tasks = [];
          this.ot = 1;
          this.otTmp = 1;
          this.initFileds();
          this.initSearch();
        } else {
          this.$router.push({ name: "notfound" });
        }
        //49531
        //console.log('enedees not found');
      }
    },
    initSearch() {

      if(this.prms!=undefined && this.prms!=null && this.prms.objectTypeId == 138){
          if(this.$store.state.app.activeGroup.id==9235 || this.$store.state.app.activeGroup.id==9351) {
            //console.log('this prmsp rop', this.prmsProp);
            if(this.prmsProp!=undefined){
              if(this.prmsProp.fillAfter!=undefined){
                if(this.prmsProp.fillAfter.tsuvaaId!=undefined && this.prmsProp.fillAfter.tsuvaaId>0){
                  this.filterModel.departId= this.prmsProp.fillAfter.tsuvaaId;  
                }
              }
            }
            //this.filterModel.departId= this.;
            if(this.prms.fieldName!=undefined){
              if(this.prms.fieldName=='organizationTaskId'){
                this.filterModel.locTypeId= 159155;
              }else if(this.prms.fieldName=='secondOrganizationTaskId'){
                this.filterModel.locTypeId= 159156;
              }
            }
          }
        }

      getSearchFields({
        params: { objectTypeId: this.ot },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.searches = res.data.fields.map((e) =>
            Object.assign(e, { val: "" })
          );
          this.searchesAfter(this.ot);
          //console.log('searches=> ', this.searches, this.filterModel);

          
        }
      });
    },
    fieldsAfter(ot){
      if(this.$store.state.app.activeGroup.id == 9344){
        if (ot == 390) {
          this.fields= this.fields.filter(x=>x.field!='langCode');
          // this.searches.forEach((f) => {
          //   if (f.field == "langCode" ) {
          //     f.flag = null;
          //   }
          // });
        }
      }
    },
    searchesAfter(ot){
      if(this.$store.state.app.activeGroup.id == 9344){
        if (ot == 138) {
          this.searches= this.searches.filter(x=>x.field!='langCode');
          // this.searches.forEach((f) => {
          //   if (f.field == "langCode" ) {
          //     f.flag = null;
          //   }
          // });
        }
      }
    },
    dispose() {
      // Object.assign(this.$data, this.$options.data());
      Object.assign(this.$data, this.$options.data.call(this));
      window.removeEventListener("resize", this.getWindowHeight);
    },
    initFileds() {
      getListFields({
        params: { objectTypeId: this.otTmp },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          let allSpan = res.data.fields.reduce(
            (sum, { span }) => sum + span,
            0
          );
          this.fields = res.data.fields.map((e) => {
            e.span = parseInt((e.span * 95) / allSpan, 10);
            return e;
          });

          this.fieldsAfter(this.otTmp);

          this.columnDefs = res.data.fields.map((f) => {
            return {
              headerName: f.title,
              field: f.field,
              sortable: true,
              filter: true,
              checkboxSelection: f.field == "taskEn",
              cellRendererFramework: "dynamicCellAg",
              cellRendererParams: { f: f },
            };
          });

          if (this.listSetting.statisticLoad) {
            this.getStatistic();
          }

          this.init();
        }
      });
    },
    init(force, taskId) {
      let self = this;
      this.loading = true;
      //console.log('force', force);
      if (force) {
        this.filterModel = { task: "", systemFlag: null };
        this.pager.current = 1;

        if (this.otTmp == 390) this.filterModel = { task: "", systemFlag: 6 };
        if (this.otTmp == 138) this.filterModel = { task: "", systemFlag: 1 };
      } else if (force == undefined) {
        if (this.otTmp == 390) this.filterModel.systemFlag = 6;
        if (this.otTmp == 138) this.filterModel.systemFlag = 1;
      }

      if (this.listSetting.chooser && this.ot == 181) {
        this.filterModel.isTender = true;
      }

      if (this.ot == 463) {
        this.pager.perPage = 200; //mal emnelgiin company list => nersiin daraallaar default-r orderlene geheer tur ingej shiidev.. server side undsen heden talbaraar default-r sortoldog boloh shaardlagatai bn tsaashda
      } else if (this.ot == 472) {
        if (hasOneOf(["vetmedclient"], this.$store.state.user.access)) {
          this.filterModel.isTender = true;
        }
      } else if (this.ot == 487 || this.ot == 488) {
        this.filterModel.isPublic = true;
      }

      //console.log('this.filterModel from INIT =>', this.filterModel);

      let _lprojId = this.project.id;
      if (this.listSetting.chooser && this.ot == 114) {
        _lprojId = 0;
      }

      let _data = {
        projectId: _lprojId,
        size: this.pager.perPage,
        skip: (this.pager.current - 1) * this.pager.perPage,
        model: this.filterModel,
      };

      if (this.listSetting.chooser && this.ot == 114) {
        _data.ot = 114;
      }

      this.tasks = [];
      this.handleLoading({ isLoading: true });
      getCoreList({
        data: _data,
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.handleLoading({ isLoading: false });
          //console.log('getCoreList', this.filterModel, res);
          this.nowDate = res.data.nowDate;
          //updateNowDate();
          //setInterval()

          this.tasksCount = res.data.allCount;

          this.tasks = res.data.tasks.map((e) =>
            Object.assign(e, {
              groupDate: self.getDateGroupName(e.createdDate),
              k: null,
            })
          );
          if (this.ot == 463) {
            this.tasks = _.orderBy(this.tasks, "task", "asc");
          }

          if (this.tasks.length > 0) {
            this.buildBoxMenu();
          }

          //# ag-grid
          this.rowData = this.tasks;

          this.loading = false;
          this.fetched = true;

          this.$emit("on-fetched");

          if (this.routeConfig.edit == 1) {
            this.editShow(0);
            this.routeConfig.edit = 0;
          } else if (this.routeConfig.detail > 0) {
            this.showDetail({ mode: 80, obj: { id: this.routeConfig.detail } });
          } else if (taskId != undefined) {
            this.showDetail({ mode: 80, obj: { id: taskId } });
          }

          this.$nextTick(function () {
            window.addEventListener("resize", this.getWindowHeight);
            this.getWindowHeight();
          });
        } else {
          this.handleLoading({ isLoading: false });
        }
      });
    },
    buildBoxMenu() {
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: this.tasks[0].id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.listMenu = res.data.task.b;
        }
      });
    },
    checkSearch(e) {
      //console.log('e', e);

      if (e.keyCode === 13) {
        this.search();
      }
    },
    search() {
      this.$refs.srchFields.filter();
      //this.init();
    },
    onSearchFired(e) {
      // console.log('emit leed haihad filter model iim bsn ' , this.filterModel);
      // console.log('onSearchFired=> ' , this.filterModel, e);
      this.filterModel = e;

      this.init();
    },
    filterReset() {
      this.searchesKey++;
      this.$refs.srchFields.reset();
    },
    exportCoreHandle() {
      this.$refs.srchFields.export();
    },
    exportCoreList(e) {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "TaskCore/getCoreExport" },
        data: {
          projectId: this.project.id,
          size: 99999,
          skip: 0,
          id: 0,
          model: e,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.showFile(res.data.file.id);
        }
      });
    },
    exportList() {
      this.handleLoading({ isLoading: true });
      let _url = "";
      let _data = {};
      if (this.ot == 472 || this.ot == 463) {
        if (this.ot == 472) {
          _url = "Vetmed/MedicineReportExcel";
          _data = {
            turulId:
              this.filterModel.locTypeId != undefined
                ? this.filterModel.locTypeId
                : null,
            angilalId:
              this.filterModel.locTypeId1 != undefined
                ? this.filterModel.locTypeId1
                : null,
            countryId:
              this.filterModel.locTypeId3 != undefined
                ? this.filterModel.locTypeId3
                : null,
            olon_uls_ner:
              this.filterModel.taskEn != undefined
                ? this.filterModel.taskEn
                : null,
            licenseExpired:
              this.filterModel.isTender != undefined
                ? !this.filterModel.isTender
                : null,
          };
        }
        if (this.ot == 463) {
          _url = "Vetmed/CompanyReportExcel";
          _data = {
            licenseExpired:
              this.filterModel.isTender != undefined
                ? !this.filterModel.isTender
                : null,
          };
        }

        request({
          api: { method: "POST", url: _url },
          data: _data,
          store: this.$store,
        }).then((res) => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            this.showFile(res.data.file.id);
          }
        });
      }
    },
    getStatistic() {
      getStatisticByProjectId({
        data: { projectId: this.project.id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.projectStat = res.data;
        }
      });
    },
    getWindowHeight() {
      if (this.taskDialog.id == 0) {
        let extras =
          this.$refs.mainHeader.offsetHeight +
          this.$refs.listHeader.offsetHeight +
          this.$refs.listFooter.offsetHeight;
        let extraSide =
          this.$refs.mainHeader.offsetHeight +
          (this.listSetting.statisticLoad ? this.$refs.sideTop.offsetHeight : 0) +
          this.$refs.sideBtm.offsetHeight;

        this.scrHeight = window.innerHeight - extras;
        this.scrSideHeight = window.innerHeight - extraSide;
      }
    },
    pageChanged(e) {
      this.pager.current = e;
      this.init();
    },
    showDetail(e) {
      //console.log('showDetail=> ', e);
      if (!this.$store.state.app.aside.minimize)
        this.handleAside({ minimize: true, maximize: false });
      if (this.listSetting.chooser) {
        this.dispose();
        this.$nextTick(() => {
          this.$emit("on-task-selected", e);
        });
      } else if (e.mode != undefined && e.mode == 80) {
        this.taskDialogSide.id = e.obj.id;
      } else {
        //console.log('yag end irlee');
        //this.taskDialog.id = 0;
        this.taskDialogSide.id = 0;
        this.$nextTick(function () {
          this.initRow(e.obj.id);
          this.taskDialogSide.id = e.obj.id;
        });
        //this.taskDialogSide.id = e.obj.id;
        // this.$nextTick(function() {
        //   this.handleLoading({ isLoading: true });
        //   this.taskDialog.id = e.obj.id;
        // });
      }
    },
    initRow(id) {
      //console.log(id);
      this.handleLoading({ isLoading: true });
      this.filterModel.id = id;
      let self = this;
      getCoreList({
        data: {
          projectId: this.project.id,
          size: 1,
          skip: (this.pager.current - 1) * this.pager.perPage,
          model: this.filterModel,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });

        if (res != false) {
          res.data.tasks = res.data.tasks.map((e) =>
            Object.assign(e, {
              groupDate: self.getDateGroupName(e.createdDate),
              k: null,
            })
          );

          //console.log('res.data.tasks', res.data.tasks.length);
          const currentIndex = this.tasks.findIndex((p) => p.id === id);
          this.tasks.splice(currentIndex, 1, res.data.tasks[0]);
          //console.log(res.data.tasks[0]);
        }
      });
    },
    editShow(id) {
      this.taskEdit.id = id;
      this.taskEdit.objectTypeId = this.ot;
      if(this.otTmp==390){
        this.taskEdit.objectTypeTmpId = this.otTmp;
      }
      this.taskEdit.projectId = this.project.id;
      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    editClosed() {
      //console.log('editClosed');
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    onEdittem(e) {
      //console.log("onEdittem=> ", e, e.parentId);
      this.taskEdit.id = e.id;
      this.taskEdit.objectTypeId = this.ot;

      this.taskEdit.parentTask =
        e.parentId == 0
          ? null
          : {
              id: e.id,
              locTypeId: e.locTypeId,
              organizationTaskId: e.organizationTaskId,
              secondOrganizationTaskId: e.secondOrganizationTaskId,
              thirdOrganizationTaskId: e.thirdOrganizationTaskId,
              fourthOrganizationTaskId: e.fourthOrganizationTaskId,
              fifthOrganizationTaskId: e.fifthOrganizationTaskId,

              st1: e.st1,
              dueStartDate: e.dueStartDate,
              dueDate: e.dueDate,

              taskEn: e.taskEn,

              locTypeId5: e.locTypeId5,
              locTypeId6: e.locTypeId6,
              locTypeId7: e.locTypeId7,
              locTypeId8: e.locTypeId8,

              fromAsset: true,
            };

      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    taskPosted(e) {
      if (e.prms.objectTypeId == 506) {
        //console.log('e.prms', e.prms);
        //this.$refs.srchFields.cmmsReRender(e.prms.parentTask.organizationTaskId, e.obj.id, e.obj.parentId);
        this.$refs.srchFields.cmmsReRender(
          e.obj.organizationTaskId,
          e.obj.id,
          e.obj.parentId
        );
      }
      //console.log('taskPosted', e);
      this.editClosed();
      this.init();
      if (e.afterMode != undefined) {
        //console.log('step 1');
        if (e.afterMode == 102) {
          //console.log('step 2');
          if (e.prms.objectTypeId == 506) {
            //console.log('step 3');
            this.editShow(0);
          } else {
            this.editShow(0);
          }
        }
      } else {
        this.showDetail({ mode: 80, obj: e.obj });
      }
    },
    taskLoaded() {
      this.handleLoading({ isLoading: false });
      this.taskDialog.show = true;
    },
    onTaskDelete(e) {
      this.taskDialog.id = 0;
      let cur = this.tasks.filter((x) => x.id == e);
      if (cur.length > 0) {
        let i = this.tasks.map((st) => st.id).indexOf(e);
        this.tasks.splice(i, 1);
        this.tasksCount = this.tasksCount - 1;
      }
    },
    onEditProfile(e) {
      this.editProfile.obj = e;
      this.editProfile.modal = true;
      //console.log('onEditProfile', e);
    },
    onAttendence(e) {
      //console.log("onAttendence=> ", e);
    },
    projectUsers() {
      this.projectEdit.render = true;
      this.$nextTick(function () {
        this.projectEdit.show = true;
      });
    },
    projectUsersClosed() {
      this.projectEdit.show = false;
    },
    projectSteps() {
      this.projectStep.show = true;
    },
    showMention() {
      this.projectEdit.show = false;
      this.projectMention.show = true;
    },
    showGroupLabel() {
      let _fname = "groupDate";
      // if (this.groupedMode == 0) {
      //   _fname = "groupDate";
      // } else if (this.groupedMode == 1) {
      //   _fname = "groupColumn";
      // } else if (this.groupedMode == 2) {
      //   _fname = "userFullName";
      // } else if (this.groupedMode == 138) {
      //   _fname = "departName";
      // }
      return _fname;
    },
    isDrawGroupDateRange(i) {
      if (this.ot == 463) return false;
      let _fname = "groupDate";
      // if (this.groupedMode == 0) {
      //   _fname = "groupDate";
      // } else if (this.groupedMode == 1) {
      //   _fname = "groupColumn";
      // } else if (this.groupedMode == 2) {
      //   _fname = "userFullName";
      // } else if (this.groupedMode == 138) {
      //   _fname = "departName";
      // }

      if (i == 0) {
        return true;
      } else if (this.tasks[i][_fname] != this.tasks[i - 1][_fname]) {
        return true;
      } else {
        return false;
      }
    },
    getDateGroupName(d) {
      let rv = "";

      if (moment(d).isSame(new Date(), "day")) {
        rv = "Өнөөдөр";
      } else if (moment(d).isSame(moment().subtract(1, "day"), "day")) {
        rv = "Өчигдөр " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(moment().subtract(2, "day"), "day")) {
        rv = "Уржигдар " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(new Date(), "week")) {
        rv = "Энэ долоо хоногт";
      } else if (moment(d).isSame(moment().subtract(1, "week"), "week")) {
        rv = "Өнгөрсөн долоо хоногт";
      } else if (moment(d).isSame(new Date(), "month")) {
        rv = "Энэ сард";
      } else if (moment(d).isSame(moment().subtract(1, "month"), "month")) {
        rv = "Өнгөрсөн сард";
      } else if (moment(d).isSame(new Date(), "year")) {
        rv = moment(d).format("MMMM") + "д";
        //rv= 'Энэ жилд';
      } else if (moment(d).isSame(moment().subtract(1, "year"), "year")) {
        rv = "Өнгөрсөн жилд";
      } else {
        rv = moment(d).format("YYYY") + " онд";
        //rv='Бусад';
      }
      return rv;
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    popoverShowShow(e) {
      this.showDetail(e);
      //# popover asuudal buren shiidsenii daraa gargah
      // if(this.popover.target== e.id)
      // {
      //   this.popoverShow= false;
      //   this.popover.key=0;
      // }else{
      //   this.popover.title= e.task;
      //   this.popover.target= e.id;
      //   this.$nextTick(()=> {
      //     this.popoverShow= true;
      //     this.popover.key++;
      //   });
      // }
    },
    onClose() {
      this.popoverShow = false;
      this.popover.key = 0;
    },
    onOk() {},
    onShow() {
      this.popover.load = true;
    },
    onShown() {},
    onHidden() {
      this.popoverShow = false;
      this.popover.key = 0;
    },
    handleClick(event, item) {
      //if (this.forceLoad) this.$refs.vueSimpleContextMenu.showMenu(event, item);
    },
    optionClicked(event) {
      window.alert(JSON.stringify(event));
    },
    forceClose() {
      this.dispose();
      this.$nextTick(() => {
        this.$emit("on-close");
      });
    },
    showPinnerUsers() {},
    updateTaskInherited(obj, mode) {
      let self = this;
      if (!this.hasPermission(["admin"])) {
        if (mode == 2 || mode == 22) {
          this.processing = true;
          if (
            this.parentTask.user != null &&
            this.parentTask.user.userId == this.$store.state.user.userId
          ) {
            if (!(this.parentTask.im != null && this.parentTask.im.pinIs)) {
              setTimeout(() => {
                self.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй.", {
                  title: "Мэдэгдэл",
                  autoHideDelay: 5000,
                  appendToast: false,
                  variant: "warning",
                  toaster: "b-toaster-bottom-left",
                });
                self.processing = false;
                self.busy = false;
              }, 500);

              return;
            }
          } else {
            if (!(obj.im != null && obj.im.pinIs)) {
              setTimeout(() => {
                self.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй...", {
                  title: "Мэдэгдэл",
                  autoHideDelay: 5000,
                  appendToast: false,
                  variant: "warning",
                  toaster: "b-toaster-bottom-left",
                });
                self.processing = false;
                self.busy = false;
              }, 500);

              return;
            }

            // setTimeout(() => {
            //   self.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй", {
            //     title: "Мэдэгдэл",
            //     autoHideDelay: 5000,
            //     appendToast: false,
            //     variant: "warning",
            //     toaster: "b-toaster-bottom-left"
            //   });
            //   self.processing = false;
            //   self.busy = false;
            // }, 500);

            // return;
          }
        }
      }

      postInheritedTask({
        data: { model: obj },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          if (mode == 888) {
            this.mediaFinder.show = false;
            this.initRow(obj.id);
          } else if (mode == 2) {
            this.processing = false;
            this.busy = false;
            this.initRow(obj.id);
          } else if (mode == 22) {
            this.initRow(obj.id);
          } else if (mode == 0) {
            this.initRow(obj.id);
          } else if (mode == 1) {
            //this.init();
            this.initRow(obj.id);
          }
        }
      });
    },
    updField(e) {
      getInheritedTask({ params: { id: e.taskId }, store: this.$store }).then(
        (res) => {
          var _model = res.data.task;
          if (e.mode == 0) {
            _model[e.field.field] = !(e.value === true);
            this.updateTaskInherited(_model, 0);
          } else if (e.mode == 2) {
            _model[e.field.field] = e.value;
            this.processingObj = _model;
            this.busy = true;
          } else if (e.mode == 22) {
            _model[e.field.field] = e.value;
            this.updateTaskInherited(_model, 22);
          } else if (e.mode == 888) {
            _model[e.field] = e.value;
            this.updateTaskInherited(_model, e.mode);
          } else if (e.mode == 1) {
            //_model[e.field] = e.value;
            //this.updateTaskInherited(_model, e.mode);
            //this.init(); //#TODO
            this.initRow(e.taskId);
          }
        }
      );
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    showMemberPoint(e) {
      //console.log()
      this.memberPoint.user = e.task.user;
      this.memberPoint.modal = true;
      //console.log('showMemberPoint', e.task.user);
    },
    isSpecialOt(ot) {
      return hasOneOf([ot], [451]);
    },
    syncGolomtDepart() {
      if (confirm("Байгууллагын бүтцийн мэдээлэл татах гэж байна?")) {
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "POST", url: "Golomt/FetchDepartment" },
          store: this.$store,
        }).then((res) => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            this.$bvToast.toast("Амжилттай", {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true,
            });
          } else {
            this.$bvToast.toast("Алдаа гарлаа", {
              title: "Мэдэгдэл",
              autoHideDelay: 5000,
              appendToast: true,
            });
          }
        });
      }
    },
    syncGolomtUsers() {
      if (
        confirm(
          "Хэрэглэгчийн мэдээлэл татах гэж байна? Хэрэглэгчийн тооноос хамаарч тодорхой хугацаа зарцуулна."
        )
      ) {
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "POST", url: "Golomt/FetchUsers" },
          data: { count: 10000 },
          store: this.$store,
        }).then((res) => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            this.$bvToast.toast("Амжилттай", {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true,
            });
          } else {
            this.$bvToast.toast("Алдаа гарлаа", {
              title: "Мэдэгдэл",
              autoHideDelay: 5000,
              appendToast: true,
            });
          }
        });
      }
    },
    isHrAdmin() {
      return hasOneOf(["hradmin"], this.$store.state.user.access);
    },
    // isSpecialAside(ot) {
    //   return false;
    //   return hasOneOf([ot], [451, 115, 114]);
    // },

    //# member finder tai holbootoi
    createdUserChanged(e) {
      this.createdUser.mode = e;
    },
    createdUserFind() {
      if (this.createdUser.mode == "1") {
        request({
          api: { url: "Hr/GetUsersByLoginName", method: "GET" },
          params: {
            loginName: this.createdUser.value,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      } else if (this.createdUser.mode == "2") {
        request({
          api: { url: "Hr/GetUsersByRegister", method: "GET" },
          params: {
            register: this.createdUser.value,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      } else if (this.createdUser.mode == "3") {
        request({
          api: { url: "Hr/GetUsersByFirstName", method: "GET" },
          params: {
            firstName: this.createdUser.value,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      }
    },
    createdUserFindAfter(res) {
      //console.log(res);
      this.createdUser.list = res.data.users;
      if (this.createdUser.list.length > 0) {
        if (this.createdUser.list.length == 1) {
          this.createdUser.curId = res.data.users[0].id;
        } else {
          this.createdUser.modal = true;
        }
      }
    },
    createdUserRemove() {
      this.taskEdit.id = id;
      this.taskEdit.objectTypeId = this.ot;
      this.taskEdit.projectId = this.project.id;
      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    onAddItemRoot(e) {
      this.taskEdit.id = 0;
      this.taskEdit.objectTypeId = this.ot;
      this.taskEdit.projectId = this.project.id;

      this.taskEdit.organizationTaskId = e.id;
      this.taskEdit.parentTask = {
        //id: e.id
        organizationTaskId: e.id,
      };

      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    onAddItem(e) {
      //console.log('onAddItem', e);
      this.taskEdit.id = 0;
      this.taskEdit.objectTypeId = this.ot;
      this.taskEdit.projectId = this.project.id;
      //# add ons
      this.taskEdit.boxId = e.boxId;
      this.taskEdit.parentId = e.id;
      this.taskEdit.parentTask = {
        id: e.id,
        locTypeId: e.locTypeId,
        organizationTaskId: e.organizationTaskId,
        secondOrganizationTaskId: e.secondOrganizationTaskId,
        thirdOrganizationTaskId: e.thirdOrganizationTaskId,
        fourthOrganizationTaskId: e.fourthOrganizationTaskId,
        fifthOrganizationTaskId: e.fifthOrganizationTaskId,

        st1: e.st1,
        dueStartDate: e.dueStartDate,
        dueDate: e.dueDate,

        taskEn: e.taskEn,

        locTypeId5: e.locTypeId5,
        locTypeId6: e.locTypeId6,
        locTypeId7: e.locTypeId7,
        locTypeId8: e.locTypeId8,

        fromAsset: true,
      };

      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    onAddWork(e) {
      //console.log(e);
      this.taskEdit.id = 0;
      this.taskEdit.objectTypeId = 508;
      //this.taskEdit.projectId = this.project.id;
      //# add ons
      this.taskEdit.boxId = e.workBoxId;
      this.taskEdit.parentId = e.id;
      this.taskEdit.parentTask = {
        id: e.id,
        locTypeId: e.locTypeId,
        organizationTaskId: e.organizationTaskId,
        secondOrganizationTaskId: e.secondOrganizationTaskId,
        thirdOrganizationTaskId: e.thirdOrganizationTaskId,
        fourthOrganizationTaskId: e.fourthOrganizationTaskId,
        taskEn: e.taskEn,
      };

      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    onSiteEdit(e) {
      this.taskEdit.id = e.id;
      this.taskEdit.objectTypeId = e.objectTypeId;
      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    onSiteAdd(e) {
      let prjs = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == e
      );
      if (prjs != undefined && prjs.length) {
        this.taskEdit.id = 0;
        this.taskEdit.projectId = prjs[0].id;
        this.taskEdit.objectTypeId = e;
        this.taskEdit.render = true;
        this.$nextTick(function () {
          this.taskEdit.show = true;
        });
      }
    },
    // getContextMenuItems(params) {
    //   console.log("getContextMenuItems", params);
    //   var result = [
    //     {
    //       name: "Alert " + params.value,
    //       action: function() {
    //         window.alert("Alerting about " + params.value);
    //       },
    //       cssClasses: ["redFont", "bold"],
    //     },
    //     {
    //       name: "Always Disabled",
    //       disabled: true,
    //       tooltip:
    //         "Very long tooltip, did I mention that I am very long, well I am! Long!  Very Long!",
    //     },
    //     "copy",
    //     "separator",
    //     "chartRange",
    //   ];
    //   return result;
    // },
    // cellClicked(e){
    //   if (this.listSetting.chooser) {
    //     this.dispose();
    //     this.$nextTick(() => {
    //       this.$emit("on-task-selected", e.data);
    //     });
    //   }
    //   else
    //     this.showDetail({mode: 80, obj: {id: e.data.id} });
    // },
    // cellContextMenu(e) {
    //   //console.log(e);
    //   //this.context.pos.top = e.event.y;
    //   //this.context.pos.left = e.event.x;
    //   this.context.rowId = e.data.id;
    //   this.contextShow = true;
    //   this.$nextTick(()=>{
    //     let bottomSub = 0;
    //     let rightSub = 0;
    //     if (window.innerHeight - e.event.y  < 122) {
    //       bottomSub = (window.innerHeight - e.event.y +122);
    //     }
    //console.log(window.innerWidth, e.event.x, this.$refs.cntxtMenu);
    //     if (window.innerWidth - e.event.x<this.$refs.cntxtMenu.clientWidth+20) {
    //       rightSub = window.innerWidth-(window.innerWidth - e.event.x +this.$refs.cntxtMenu.clientWidth);
    //     }

    //     //this.context.pos.left = e.event.clientX - e.event.x + 10 - rightSub;
    //     this.context.pos.top = bottomSub!=0? bottomSub : e.event.y;
    //     this.context.pos.left = rightSub!=0? rightSub : e.event.x;
    //   })

    //   //console.log(e);
    // },
    // closeContextMenu() {
    //   this.context.rowId = 0;
    //   this.contextShow = false;
    // },
    // onGridReady(params){
    //   this.gridApi = params.api;
    //   console.log(params);
    // },
    onDuplicated(e) {
      this.init();
      this.taskDialogSide.id = 0;
      //console.log('onDuplicated=> ', e.course);

      e.course.startDate = moment(e.course.startDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      e.course.endDate = moment(e.course.endDate).format("YYYY-MM-DD HH:mm:ss");
      e.course.requestStartDate = moment(e.course.requestStartDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      e.course.requestEndDate = moment(e.course.requestEndDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      e.exams.forEach((x) => {
        x.startDate = moment(x.startDate).format("YYYY-MM-DD HH:mm:ss");
        x.endDate = moment(x.endDate).format("YYYY-MM-DD HH:mm:ss");
      });

      this.duplicateData.course = e.course;
      this.duplicateData.exams = e.exams;
      this.duplicateData.modal = true;
      this.$bvToast.toast("Амжилттай", {
        title: "Мэдэгдэл",
        autoHideDelay: 3000,
        appendToast: true,
      });
    },
    duplicateDataSubmit() {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "v2/learn/DuplicateCourseAfterSave" },
        data: {
          id: this.duplicateData.course.id,
          task: this.duplicateData.course.task,
          startDate: this.duplicateData.course.startDate,
          endDate: this.duplicateData.course.endDate,
          requestStartDate: this.duplicateData.course.requestStartDate,
          requestEndDate: this.duplicateData.course.requestEndDate,
          exams: this.duplicateData.exams,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.duplicateData.modal = false;
          this.init();
          //console.log(res);
        }
      });
    },
    taskDelete(e) {
      request({
        api: { method: "GET", url: "Task/DeleteBefore" },
        params: { id: e.id },
        store: this.$store,
      }).then((res) => {
        //this.processing = false;
        if (res != false) {
          if (res.data.result == 1) {
            //this.processing = true;
            request({
              api: { method: "POST", url: "Task/Delete" },
              params: { id: e.id },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                if (res.data.result == 1) {
                  this.$refs.gomenu.deleteAfter();
                  this.init();
                  this.$bvToast.toast("Амжилттай", {
                    title: "Амжилттай",
                    autoHideDelay: 5000,
                    appendToast: true,
                  });
                } else {
                  this.$refs.gomenu.deleteAfter();

                  this.$bvToast.toast(`${res.data.info}`, {
                    title: "Амжилтгүй",
                    autoHideDelay: 5000,
                    appendToast: true,
                  });
                }
              }
            });
          } else {
            this.$refs.gomenu.deleteAfter();
            this.$bvToast.toast(`${res.data.info}`, {
              title: "Устгах эрхгүй байна",
              autoHideDelay: 5000,
              appendToast: true,
            });
          }
        } else {
          this.$refs.gomenu.deleteAfter();

          this.$bvToast.toast(`${res.data.info}`, {
            title: "Амжилтгүй",
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      });
    },
  },
  // computed: {
  //   rows() {
  //     return this.tasksCount
  //   }
  // }
  watch: {
    "$root.$route"() {
      // console.log('route soligdson uu');
      // this.searchesKey++;

      this.dispose();
      this.$nextTick(() => {
        this.forceLoad = true;
        this.$nextTick(() => {
          this.build(
            this.$route.params.ot,
            this.$route.params.edit,
            this.$route.params.detail
          );
        });
      });
    },
    // contextShow(value) {
    //   if (value) {
    //     document.body.addEventListener("click", this.closeContextMenu);
    //   } else {
    //     document.body.removeEventListener("click", this.closeContextMenu);
    //   }
    // },
  },
};
</script>

<style lang="scss">
.bg-core-light {
  background: #f5f6fa;
}
.text {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 16px;
  margin: 0 auto;
  line-height: 1.2;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  width: 100%;
  font-family: "Arial", sans-serif;
}
.row.highlight:hover > * {
  background: #ffd190 !important;
  /* background-color: rgba(0, 0, 0, 0.05); */
}
.clmn-pppvr .popover-body {
  padding: 0;
}
.bg-list-header > div {
  font-size: 8px;
  font-weight: 500;
  overflow: hidden;
}
.d-list {
  // font-family: "Arial", sans-serif;
  color: rgba(27, 46, 75, 0.9);
}
.core-list-group {
  /* background: rgb(238, 238, 238) !important; */
  /* background-color: rgba(0, 0, 0, 0.1); */
  /* background-color: #fafbfc; */
  // background-color: rgba(229, 233, 242, 0.8);
  /* border-top: 1px solid rgb(221, 221, 221);
  border-bottom: 1px solid rgb(221, 221, 221); */
  // div {
  //   color: #e3e7ed;
  // }
}
.list-row {
  min-height: 27px;
  border-bottom: 1px solid #f4f5f8;
}
// .d-row:nth-of-type(even) {
//   /* background: #f5f5f5; */
//   // background-color: rgba(0, 0, 0, 0.02);
// }
.list-row .bd-l {
  border-left: 1px solid #f4f5f8;
}
.go-core-list-footer{
  .page{
    .page-item{
      // border: 1px solid red;
      button, span{
        border-radius: 5px !important;
      }
    }
  }
}
</style>